import { AnchorProps } from "client/Components";
import { NavigationLinkContext } from "client/Contexts/NavigationLinkContext";
import { Navigation, NavigationOptions } from "client/Navigation";
import { ReactElement, Ref, forwardRef } from "react";

type BaseProps = Omit<AnchorProps, "href">;

export type NavigationLinkProps = BaseProps & {
	navigation: Navigation | string;
	options?: NavigationOptions;
};

export const NavigationLink = forwardRef(
	(props: NavigationLinkProps, ref: Ref<HTMLAnchorElement>): ReactElement => {
		return (
			<NavigationLinkContext.Consumer>
				{(context) => context.render(props, ref)}
			</NavigationLinkContext.Consumer>
		);
	}
);
NavigationLink.displayName = "NavigationLink";